import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from 'src/app/utils/url-utils';
import { errorHandl } from 'src/app/utils/network-utils';

@Injectable({
  providedIn: 'root'
})
export class PayorService {

  constructor(private http: HttpClient) { }

    savePayor(payorId, payload): Observable<any> {
    if (payorId) {
      return this.http.put<any>(urls.BASE_URL + urls.PAYOR_URL + '/' + payorId, payload).pipe(
        catchError(errorHandl)
      );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.PAYOR_URL, payload).pipe(
        catchError(errorHandl)
      );
    }
  }

   getPayorList(queryParams?): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.PAYOR_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

   getPayorById(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.PAYOR_URL + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }
}
